import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { compose } from "redux";

import RightPanel from "components/Wizard/RightPanel/RightPanel";

import * as runReducer from "containers/Run/reducer";
import { PANEL_MODES } from "containers/Run/reducer";

import * as wizardReducer from "containers/Wizard/reducer";
import * as setupReducer from "containers/Setup/reducer";

import SelectedModel from "containers/Wizard/RightPanel/SelectedModel";
import ModelGroups from "containers/Wizard/RightPanel/ModelGroups";

import { isEnabled } from "utils/featureFlags";

class RightPanelContainer extends React.PureComponent {
  render() {
    const { panelMode } = this.props;
    return (
      <RightPanel {...this.props}>
        {panelMode === PANEL_MODES.SELECTED_MODEL ? <SelectedModel {...this.props} /> : ""}
        {panelMode === PANEL_MODES.MODEL_GROUPS ? <ModelGroups {...this.props} /> : ""}
      </RightPanel>
    );
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    scrollToEnd: () => {
      dispatch(wizardReducer.scrollToEnd(0));
      return dispatch(runReducer.updateIsRightOpen(ownProps.id, ownProps.blueprintId, false));
    },

    continueWithModel: () => {
      dispatch(runReducer.updateIsNextStep(ownProps.id, true));
      dispatch(wizardReducer.scrollToEnd(0));
      return dispatch(runReducer.updateIsRightOpen(ownProps.id, ownProps.blueprintId, false));
    },

    updateChooseModel: (model) => dispatch(runReducer.updateFeatureSelection(ownProps.id, model, true))
  };
};

const mapStateToProps = (state, ownProps) => {
  const models = runReducer.getTransformedSortedModels(state, ownProps.id);
  const bestModel = models && models.length > 0 ? models[0] : undefined;
  const selModel = runReducer.getSelModel(state, ownProps.id) ? runReducer.getSelModel(state, ownProps.id) : bestModel;

  return {
    model: selModel,
    models: models,
    panelMode: runReducer.getPanelMode(state, ownProps.originalId),
    netImpactLabel: setupReducer.getNetImpactLabel(state, ownProps.id),
    isContinuous: setupReducer.getOutcomeType(state, ownProps.id) === "number",
    isQuickRun: setupReducer.getIsQuickRun(state, ownProps.id)
  };
};

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect, withRouter)(RightPanelContainer);
